<template>
  <div class="select-category-box" @click.stop="closeGroup">
    <div class="select-category">
      <div class="header row">
        <span>选择分组</span>
        <i @click="closeGroup" class="cancel-group-next"></i>
      </div>
      <div class="content">
        <div class="group-name-box row">
          <span
            v-for="(item,ind) in groupNameList"
            :key="ind"
            :class="[tag.includes(item)?'group-name-item active':'group-name-item']"
            @click="selectGroup(item)"
          >{{item}}</span>
        </div>
        <div class="add-group-btn row" @click="addGroup">
          <i class="add-group"></i>
          <span>添加分组</span>
        </div>
      </div>
      <div class="footer">
        <div class="footer-btn">
          <el-button class="cancel-btn" @click="deselectGroup">不选择分组</el-button>
          <el-button
            class="confirm-btn"
            :class="[tag.length?'active-confirm':'']"
            @click="confirmGroup"
          >确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';

export default {
  data() {
    return {
      groupNameList: [],
      tag: [],
      username: ''
    };
  },
  props: {
    checkedTag: Array
  },
  methods: {
    getGroupList() {
      QuestionQuery.focusGroupsList(this.username).then(res => {
        // eslint-disable-next-line
        res = res.filter(v => {
          if (!(v === '无类别' || v === '全部')) {
            return v;
          }
        });
        this.groupNameList = res;
      });
    },
    selectGroup(item) {
      const ind = this.tag.indexOf(item);
      if (ind === -1) {
        this.tag.push(item);
      } else {
        this.tag.splice(ind, 1);
      }
    },
    deselectGroup() {
      this.$emit('continueTo');
    },
    confirmGroup() {
      if (this.tag.length) {
        // 传递分组名称
        this.$emit('continueTo', this.tag);
      }
    },
    closeGroup(e) {
      if (
        e.target.className === 'select-category-box' || e.target.className === 'cancel-group-next'
      ) {
        this.$emit('cancelOperation');
      }
    },
    addGroup() {
      this.$emit('addGroup');
    }
  },
  mounted() {
    this.tag = this.checkedTag;
    this.username = authService.getLoggedUserName();
    this.getGroupList();
  }
};
</script>

<style lang="scss" scoped>
.select-category-box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 6;
  background-color: rgba(0, 0, 0, 0.4);
  .select-category {
    width: 438px;
    height: 329px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    .header {
      width: 100%;
      height: 44px;
      line-height: 44px;
      background-color: #ffffff;
      box-shadow: inset 0px -1px 0px 0px #f7f7fa;
      justify-content: space-between;
      span {
        padding-left: 24px;
        font-size: 14px;
        letter-spacing: 0px;
        color: #171f46;
      }
      i {
        width: 16px;
        height: 16px;
        background-image: url("../../assets/img/close.svg");
        margin: 15px 24px;
        cursor: pointer;
      }
    }
    .content {
      width: 100%;
      height: 220px;
      padding: 17px 24px;
      overflow: auto;
      .group-name-box {
        flex-wrap: wrap;
        padding-bottom: 10px;
        .group-name-item {
          border-radius: 2px;
          border: solid 1px #e8e8e8;
          padding: 7px 12px;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #464d6c;
          margin-right: 10px;
          margin-bottom: 10px;
          cursor: pointer;
        }
        .active {
          border: solid 1px #45a8cc;
          color: #45a8cc;
        }
      }
      .add-group-btn {
        width: 92px;
        height: 32px;
        background-color: #f7f8fc;
        border-radius: 2px;
        padding: 7px 0px;
        cursor: pointer;
        .add-group {
          width: 16px;
          height: 16px;
          background-image: url("../../assets/img/add-group-btn.svg");
          margin-top: 1px;
          margin-right: 4px;
          margin-left: 12px;
        }
        span {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 18px;
          letter-spacing: 0px;
          color: #464d6c;
        }
      }
    }
    .footer {
      width: 100%;
      height: 64px;
      background-color: #ffffff;
      box-shadow: inset 0px 1px 0px 0px #f7f7fa;
      padding: 16px 0;
      position: relative;
      .footer-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 178px;
        height: 32px;
        .cancel-btn {
          height: 32px;
          width: 102px;
          padding: 0;
          font-size: 14px;
          color: #464d6c;
          background-color: #f7f8fc;
          border-radius: 2px;
          border: none;
          &:hover {
            color: #464d6c;
            background-color: #eaeaed;
          }
          &:focus {
            color: #464d6c;
            background-color: #eaeaed;
          }
          &:active {
            color: #464d6c;
            background-color: #eaeaed;
          }
        }
        .confirm-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          font-size: 14px;
          margin-left: 16px;
          color: #ffffff;
          background-color: rgba($color: #45a8cc, $alpha: 0.4);
          border-radius: 2px;
          border: none;
        }
        .active-confirm {
          background-color: #45a8cc;
          &:hover {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:focus {
            color: #ffffff;
            background-color: #3e97b8;
          }
          &:active {
            color: #ffffff;
            background-color: #3e97b8;
          }
        }
      }
    }
  }
}
</style>
